import axios, { getAuthHeaders, getFormDataHeaders } from "./config";

export default {
  all: function() {
    return axios.get("/processes", {
      headers: getAuthHeaders(),
    });
  },

  store: function(process) {
    return axios.post("/processes", process, {
      headers: getFormDataHeaders(),
    });
  },
  show: function(process_id) {
    return axios.get(`/process/${process_id}`, {
      headers: getAuthHeaders()
    })
  },

  update: function(data) {
    return axios.put(`/processes/${data.id}`, data, {
      headers: getAuthHeaders(),
    });
  },

  delete: function(processID) {
    return axios.delete(`/processes/${processID}`, {
      headers: getAuthHeaders(),
    });
  },

  deleteDocumentFromProcess: function(data) {
    return axios.post(`/process/delete-document`, data, {
      headers: getAuthHeaders(),
    });
  },

  storeProcess: function(payload) {
    for (let i = 0; i < payload.nodes.length; i++) {
      for (let j = 0; j < payload.nodes[i].approvers.length; j++) {
        payload.nodes[i].approvers[j].id = payload.nodes[i].approvers[j].id != 0 ? 
          payload.nodes[i].approvers[j].id : null ;
        
      }
    }
    return axios.post('/process/store', payload, {
      headers: getAuthHeaders(),
    });
  },

  updateProcess: function(payload) {
    for (let i = 0; i < payload.nodes.length; i++) {
      for (let j = 0; j < payload.nodes[i].approvers.length; j++) {
        payload.nodes[i].approvers[j].id = payload.nodes[i].approvers[j].id != 0 ? 
          payload.nodes[i].approvers[j].id : null ;
        
      }
    }
    
    return axios.post('/process/update', payload, {
      headers: getAuthHeaders(),
    });
  },

  updateProcessStatus: function(processId) {
    return axios.put(`/processes/status/${processId}`, null, {
        headers: getAuthHeaders()
    });
},

  showProcess: function(process_id) {
    return axios.get('/process/show/' + process_id, {
      headers: getAuthHeaders(),
    });
  },

  getDocuments: function(process_id) {
    return axios.get('/process/get-documents/' + process_id, {
      headers: getAuthHeaders(),
    });
  },

  initiateProcess: function(payload) {
    return axios.post('/process/initiate', payload, {
      headers: getAuthHeaders(),
    });
  },
};